import $ from 'jquery'

$(document).on('click', '.dhsv_vc_flip_grid .flip-grid-card', function flipGridToggle(e) {
  e.preventDefault()
  const $btn = $(this)
  const next = $btn.attr('aria-expanded') !== 'true'
  $btn.attr('aria-expanded', next)
  $btn.toggleClass('is-flipped', next)
})
